import React, { HTMLAttributes } from 'react';
import { useSelector } from 'react-redux';
import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import { ImmutableRootState } from '@uncinc/react-drupal-core/types';
import { Menu } from '@uncinc/react-drupal-core';

import useClasses from '../../../hooks/useClasses';

import {
  DOMAIN_ZELFHULP_ALCOHOL,
  URL_ALLES_OVER_DRINKEN,
  URL_JELLINEK,
  URL_VERSLAVINGSKUNDE_NEDERLAND,
} from '../../../config/constants';

import LogoJellinek from '../../../assets/images/logos/vendor/logo-jellinek.png';
import LogoVerslaving from '../../../assets/images/logos/vendor/logo-verslavingskunde-NL.svg';
import LogoDrinken from '../../../assets/images/logos/vendor/logo-allesoverdrinken.svg';
import { CoreLink } from '../../../components';
import { ImmutableMenuItem } from '..';

import './style.scss';

interface MenuProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
}

interface ItemProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  item: any;
}

const MenuFooterItem: React.FC<ItemProps> = ({ item }) => {
  const href: string = String(item.getIn(['link', 'url'], ''));
  const title: string = String(item.getIn(['link', 'title'], 'Untitled'));

  return (
    <li key={href}>
      <CoreLink className="menu-link" to={href}>
        {title}
      </CoreLink>
    </li>
  );
};

const MenuFooter: React.FC<MenuProps> = ({
  className,
}) => {
  const { buildClass, joinClasses } = useClasses('MenuFooter');
  const currentDomain = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['uiInternal', 'currentDomain', 'raw'], ''));

  return (
    <div className={joinClasses(className, buildClass())}>
      <Container>
        <footer className={joinClasses(buildClass('inner'), 'row')}>
          <div className="col-12">
            <div className={buildClass('wrapper')}>
              <div className={buildClass('logos')}>
                <a href={URL_JELLINEK} target="_blank" rel="noreferrer">
                  <img src={LogoJellinek} alt="Logo Jellinek" />
                </a>
                {currentDomain === DOMAIN_ZELFHULP_ALCOHOL && (
                  <>
                    <a href={URL_ALLES_OVER_DRINKEN} target="_blank" rel="noreferrer">
                      <img src={LogoDrinken} alt="Logo Alles over drinken" />
                    </a>
                    <a href={URL_VERSLAVINGSKUNDE_NEDERLAND} target="_blank" rel="noreferrer">
                      <img src={LogoVerslaving} alt="Logo Verslavingskunde NL" />
                    </a>
                  </>
                )}
              </div>
              <Menu id="footer">
                {(items: ImmutableMenuItem[]) => (
                  <ul className={buildClass('items')}>
                    {items.map((item: ImmutableMenuItem) => (
                      <MenuFooterItem
                        key={item.getIn(['link', 'title'], '')}
                        item={item}
                      />
                    ))}
                  </ul>
                )}
              </Menu>
            </div>
          </div>
        </footer>
      </Container>
    </div>
  );
};

export default MenuFooter;
